import { Box, Column, Flex, Typography } from '@tempmee/react';
import { type ReactNode } from 'react';
import { SmartTooltip } from '~/commonComponents';
import InfoIcon from '~/images/icons/Info';
import { colors } from '@tempmee/tailwind';

interface IInviteSubCardProps {
  title: string;
  tooltip?: ReactNode;
  children: ReactNode;
  testId?: string;
  /** Dims the whole card (title, list, toggles, notes) and blocks interaction. */
  disabled?: boolean;
}

export const InviteSubCard = ({
  title,
  tooltip,
  children,
  testId,
  disabled = false,
}: IInviteSubCardProps) => (
  <Column
    data-testid={testId}
    data-cy={testId}
    aria-disabled={disabled || undefined}
    gap={4}
    style={{
      backgroundColor: colors.shades[0],
      borderRadius: 8,
      padding: '10px 8px 24px',
      boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15), 0px 3px 5px rgba(0, 0, 0, 0.15)',
      minWidth: 670,
      opacity: disabled ? 0.5 : 1,
      pointerEvents: disabled ? 'none' : 'auto',
    }}
  >
    <Column gap={2} style={{ padding: '0 24px' }}>
      <Flex direction="row" align="center" gap={1}>
        <Typography bold style={{ fontSize: 18 }} color={colors.neutral[600]}>
          {title}
        </Typography>
        {tooltip && (
          <SmartTooltip position="bottom" content={tooltip}>
            <InfoIcon color={colors.neutral[300]} />
          </SmartTooltip>
        )}
      </Flex>
      <Box style={{ height: 1, backgroundColor: colors.neutral[100], marginBottom: 8 }} />
    </Column>
    {children}
  </Column>
);
